import { render } from "./ItemKeyring.vue?vue&type=template&id=14966861&scoped=true"
import script from "./ItemKeyring.vue?vue&type=script&lang=js"
export * from "./ItemKeyring.vue?vue&type=script&lang=js"

import "./ItemKeyring.vue?vue&type=style&index=0&id=14966861&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14966861"]])

export default __exports__